import { RequestState } from '../../constants/request-state';
import { Loan } from '../../types/loan/Loan';
import { useAppSelector } from '../useAppSelector';
import { useLoan } from './useLoan';

interface UseStoreLoanOrFetchResult {
    loan: Loan | undefined;
    loanRequestState: RequestState;
}

export function useStoreLoanOrFetch(loanId?: number): UseStoreLoanOrFetchResult {
    const loanFromStore = useAppSelector(s =>
        loanId != null ? s.loan.loans.find(l => l.id === loanId) : undefined,
    );
    const skipFetch = loanId == null || !!loanFromStore;
    const { loan: fetchedLoan, requestState } = useLoan(loanId, skipFetch);

    return {
        loan: loanFromStore || fetchedLoan,
        loanRequestState: loanFromStore ? RequestState.success : requestState,
    };
}
